import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { UserTagsResponse } from '../models/userTagResponse';
import { UsersRequest } from '../models/usersRequest';
import { UserWithTagNamesResponse } from '../models/userWithTagNamesResponse';
import { LoggingService } from './logging.service';
import { UserTagsWithAssignmentNameRequest } from '../models/userTagsWithAssignmentNameRequest';
import { GetAllTagsRequest } from '../models/getAllTagsRequest';
import { Assignment } from '../models/assignment';

@Injectable({
  providedIn: 'root'
})
export class UserTagCrudService {
  

  constructor(private httpClient : HttpClient, private apiService: ApiService,
              private loggingService : LoggingService) { }

  usersRequest : UsersRequest = new UsersRequest();

  addTagToUser(userTagsWithAssignmentNameRequest : UserTagsWithAssignmentNameRequest) : Observable<UserTagsResponse> {
      return this.httpClient.post<UserTagsResponse>(this.apiService.getUrl('user-tag'), userTagsWithAssignmentNameRequest);
  }
  
  getAllTagsAssignedToUsers(userIds : number[]) : Observable<UserWithTagNamesResponse[]> { 
    this.usersRequest.userIds = userIds;
    return this.httpClient.post<UserWithTagNamesResponse[]>( 
      this.apiService.getUrl('user-tag/list'), this.usersRequest);
  }

  getAllQuestion(getAllTagsRequest : GetAllTagsRequest) : Observable<UserTagsResponse> {
    this.loggingService.logDebug("Retrieving all questions assigned to user id " 
      + getAllTagsRequest.userId + " under assignment id" + getAllTagsRequest.assignmentId);
    return this.httpClient.post<UserTagsResponse>(this.apiService.getUrl(`user-tag/assignment`), getAllTagsRequest);
  }

  getAllAssignment(userId : number) : Observable<Assignment[]> {
    this.loggingService.logDebug("Retrieving all assignment assigned to user id " + userId);
    return this.httpClient.get<Assignment[]>(this.apiService.getUrl(`user-tag/assignment/${userId}`));
  }

  getAssignmentByAssignmentId(assignmentId : number) : Observable<Assignment[]> {
    this.loggingService.logDebug("Retrieving all assignment assigned to user id " + assignmentId);
    return this.httpClient.get<Assignment[]>(this.apiService.getUrl(`user-tag/assignment/details/${assignmentId}`));
  }

  updateAssignmentRemainingTime(assignmentId: number, remainingTime: number): Observable<any> {
    const payload = {
      remainingTime: remainingTime
    };
    return this.httpClient.put(this.apiService.getUrl(`user-tag/assignment/${assignmentId}`), payload);
  }

}
